
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.407 2.192h-4.286v-.505c0-.854-.695-1.55-1.55-1.55H6.429c-.854 0-1.55.695-1.55 1.55v.506H.594a.5.5 0 000 1h1.961v10.089c0 .873.623 1.583 1.389 1.583h7.113c.767 0 1.39-.71 1.39-1.583V3.192h1.961a.5.5 0 10-.001-1zm-8.528-.505c0-.303.247-.55.55-.55h2.143c.303 0 .55.247.55.55v.506H5.879v-.506zm5.567 11.594c0 .344-.205.583-.39.583H3.943c-.184 0-.389-.239-.389-.583V3.192h7.892v10.089z"}}),_c('path',{attrs:{"d":"M6.019 4.651a.453.453 0 00-.453.453v7.025a.453.453 0 00.906 0V5.104a.454.454 0 00-.453-.453zM8.983 4.651a.453.453 0 00-.453.453v7.025a.453.453 0 00.906 0V5.104a.453.453 0 00-.453-.453z"}})])
          )
        }
      }
    